import React from 'react';

import { Button, Stack } from '@mui/material';

import { TypoPoppins, TypoSerif } from '../../../../Components/Typo';

function Notification() {
  return (
    <Stack
      px={3}
      width='fit-content'
      mx='auto'
      my={8}
      alignItems='center'
      gap={4}
    >
      <TypoSerif variant='h4' textAlign='center' mb={4}>
        Thank you
      </TypoSerif>
      <TypoPoppins textAlign='center'>
        Our Officer will Contact you soon!! thank you
      </TypoPoppins>
      <Button color='blue' sx={{ px: 8 }} href='/'>
        Home
      </Button>
    </Stack>
  );
}

export default Notification;
